import { useEffect, useRef } from "react";
import { useHistory, withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isMobile } from "react-device-detect";
import fetchRoute from "../utils/routes"
import { getLocalStorage, setLocalStorage } from "../utils/localStorageUtil"


const GenericWrapper = (props) => {
	const history = useHistory();
	const previousLocation = useRef();
	useEffect(() => {
		if (isMobile) {
			document.body.className += " mobile";
		}
	}, []);
	
	useEffect(() => {
		history.listen((location) => {
			
			const mainPath = location.hash?.split("/")?.[1]
			const prevMainPath = previousLocation.current?.split("/")?.[1]
			
			if(prevMainPath !== mainPath){
				fetch("/version.json?bust="+new Date().getTime()).then((res)=>res.json()).then((data)=>{
					const version = getLocalStorage("appVersion","_")
					if(version === null || (version.commitId && version.commitId !== data.commitId)){
						const newVersion = setLocalStorage("appVersion",data,"_")
						//If setting a fresh version is successfull
						if(newVersion){
							window.location.reload(true);
						}
					}
				}).catch(() => {});
			}

			if (location.hash !== previousLocation.current) {
				if (window?.Appcues) window.Appcues.page();
				previousLocation.current = location.hash;
			}
		});
	}, []);

	return props.children;
};

export default withRouter(
	connect(
		(state) => {
			return {
				segmentDisabledEvent:
					state.brand?.client_config?.segment_config?.disabled_events,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(GenericWrapper)
);
